import { useQueryClient } from "@tanstack/react-query";

import type {
  AddBusinessReviewPayload,
  AddBusinessReviewResponse,
} from "@/schemas/review";
import { notify } from "@/utils";
import { Logger } from "@/utils/logger";

import { addBusinessReview } from "../api/reviewApi";
import { QueryKeys } from "../queryKeys";
import { useCustomMutation } from "../queryUtils";

export function useAddBusinessReview(employerId: number) {
  const queryClient = useQueryClient();
  return useCustomMutation<
    AddBusinessReviewResponse,
    Record<string, unknown>,
    AddBusinessReviewPayload
  >(addBusinessReview, {
    onError: (error: Record<string, unknown>) => {
      Logger.error("Add business review failed:", error);
      notify.error("Failed to submit review. Please try again.");
    },
    onSuccess: (data) => {
      // Invalidate reviews and profile
      queryClient.invalidateQueries({
        queryKey: [QueryKeys.BUSINESS_REVIEWS, employerId],
      });
      queryClient.invalidateQueries({
        queryKey: [QueryKeys.BUSINESS_PROFILE, employerId],
      });
      return data;
    },
  });
}
